import { Theme, ThemeOptions } from "@mui/material/styles";
import { TEditorState } from "../slices/editor/types";
import { StringHeaderIdentifier } from "@tanstack/react-table";

export interface IAffiliateDataResponse {
  affiliateid: number;
  affiliatename: string;
  callbackurl: string;
  distributorid: string;
  languageid: string;
  marketid: string;
  status: string;
}

export interface IAffiliateState {
  themebuilder: string;
  loading: boolean;
  error: string | undefined;
  data: IAffiliateDataResponse | null;
  id: number | null;
  name: string | null;
  username: string | null;
}

export interface IRootStateType {
  id?: number | null;
  editor: TEditorState;
  themeId: string;
  themeObject: Theme;
  themeOptions: ThemeOptions;
  themeInput: string;
  loadedFonts: Set<string>;
  activeTab: string;
  themeConfigOpen: boolean;
  auth: TAuth;
  affiliate: IAffiliateState;
  updateThemeButton: IUpdateThemeData | null;
  editorThemeState: boolean;
  affiliateTheme: ThemeOptions;
  savedThemes: {
    [themeId: string]: {
      id: string;
      name: string;
      themeOptions: ThemeOptions;
      fonts: string[];
      lastUpdated: string;
    };
  };
}

export interface IThemeChanges {
  id: number | null;
  // themeId: string;
  themeOptions: ThemeOptions;
  themeObject: Theme;
  savedThemes: {
    [themeId: string]: {
      id: string;
      name: string;
      themeOptions: ThemeOptions;
      fonts: string[];
      lastUpdated: string;
    };
  };
  themeConfigOpen: boolean;
  editorThemeState: boolean;
  affiliateTheme: ThemeOptions;
  themeInput: string;
}

export interface IAuthState {
  editor: TEditorState;
  themeId: string;
  id?: number | null;
  themeObject: Theme;
  themeOptions: ThemeOptions;
  savedThemes: Record<string, TSavedTheme>;
  loadedFonts: Set<string>;
  activeTab: string;
  themeConfigOpen: boolean;
  auth: TAuth;
  affiliate: IAffiliateState;
  editorThemeState: boolean;
  affiliateTheme: ThemeOptions;
}

export interface IUser {
  themeId: string;
  id?: number | null;
  savedThemes: Record<string, TSavedTheme>;
  loadedFonts: Set<string>;
  activeTab: string;
  themeConfigOpen: boolean;
  auth: TAuth;
  affiliate: IAffiliateState;
  editorThemeState: boolean;
  __v?: number;
  updatedBy: {
    id?: number | null;
  };
}

export interface IAuth {
  userEmail: string;
  auth: boolean;
  privilege: string;
}

export type TAuth = {
  authStatus: boolean;
  editor: boolean;
  publisher: boolean;
  user: boolean;
  username: string;
  loading: boolean;
  error: string | null;
  status: number | null;
  statusMessage: string;
  privilege: string;
  affiliateId?: number | null;
  loginTimestamp: number;
  password: string;
  sessionid: string;
  vmLoginTimestamp: number;
};

export interface IAuthLogin {
  username: string;
  sessionid: string;
  status: number;
  statusMessage: string;
  severity: number;
  data: {
    privilege: string;
    affiliateId: number | null;
  };
}

export interface IAuthLoginUser {
  status: number;
  statusMessage: string;
  data: {
    username: string;
    sessionid: string;
    userdefault: {
      themeeditorallowed: string;
    };
    distributorprofile: {
      affiliateid: number;
      theme: ThemeOptionsType;
    };
  };
}

export type TSavedTheme = {
  id: string;
  name: string;
  themeOptions: ThemeOptions;
  fonts: string[];
  lastUpdated: string;
};

export type TNewSavedTheme = Omit<TSavedTheme, "id">;

export type TPreviewSize = "xs" | "sm" | "md" | "lg" | "xl" | false;

export type Affiliate = {
  id: number | null;
  name: string | null;
};

export interface ILoginPayload {
  userName: string;
  privilege: string;
}

export interface IRequestpublish {
  affiliateid: any;
  action: string;
  status: number | null;
  statusMessage: string;
}

export interface ILogin {
  username?: string;
  password?: string;
  privilege?: string;
  sessionid?: string;
}

export interface IThemeUpdate {
  sessionid: string;
  username: string;
  request: {
    affiliateid?: number | null;
    action?: string;
    message?: StringHeaderIdentifier;
    theme?: any;
  };
}

export interface Palette {
  header: {
    backgroundcolor: string;
    textcolor: string;
    button: {
      background: string;
      color: string;
      border: string;
      hoverbackground: string;
      hovercolor: string;
    };
  };
}

export interface IAffilateBody {
  request: {
    affiliateid?: number | null;
    themebuilder?: string | null;
  };
  sessionid?: string;
  username?: string;
}

export interface IAffilateDataBody {
  username: string;
  sessionid: string;
  failstatus: number;
  request: {
    themebuilder?: string | null;
  };
}

export interface IRequestType {
  affiliateid?: number | null;
  affiliatename?: string;
  theme?: {
    // live?: any;
    preview?: any;
  };
}

export interface IAffilatiRequestId {
  status: number | null;
  data: {
    affiliates: IAffilatiRequestIdData[];
  };
}

export interface IAffilatiRequestIdData {
  affiliateid: number;
  affiliatename: string;
  theme: {
    preview: ThemeOptionsType;
  };
}

export interface IAffilatiDataRequest {
  data: {
    affiliates?: {
      affiliateid?: number | null;
      affiliatename?: string;
    };
  };
}

export interface IAffilateRequest {
  affiliateid: number | null;
  affiliatename: string;
  loading: boolean;
  error: string | null;
  status: string | null;
  affiliates: any;
  preview: ThemeOptionsType | null;
}

export interface IAffiliateItem {
  id: number | null;
  name: string | null;
}
export interface IAffiliateResponse {
  data: {
    affiliates: any[];
  };
}
export interface IaffilateData {
  loading: boolean;
  affiliates: any;
}

export interface ThemeOptionsType {
  themeOptions: {
    palette: {
      header: {
        backgroundColor: string;
        textColor: string;
        button: {
          buttonBackground: string;
          buttonColor: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
        };
      };
      navbar: {
        backgroundColor: string;
        textColor: string;
      };
      errormessage: {
        backgroundColor: string;
        textColor: string;
      };
      warningmessage: {
        backgroundColor: string;
        textColor: string;
      };
      linktext: {
        color: string,
        hoverColor: string,
      },
      message: {
        backgroundColor: string;
        textColor: string;
      };
      body: {
        backgroundColor: string;
        textColor: string;
      };
      button: {
        primary: {
          buttonBackground: string;
          buttonColor: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
          buttonBorder: string;
          buttonBoxshadow: string;
          buttonHoverBorder: string;
          buttonBoxHoverShadow: string;
        };
        secondary: {
          buttonBackground: string;
          buttonColor: string;
          buttonHoverBackground: string;
          buttonHoverColor: string;
        };
      };
      card: {
        backgroundColor: string;
        textColor: string;
      };
      subfooter: {
        backgroundColor: string;
        textColor: string;
      };
      footer: {
        backgroundColor: string;
        textColor: {
          primary: {
            textColor: string;
          };
          secondary: {
            textColor: string;
          };
        };
      };
    };
    typography?: {
      fontFamily: string;
    };
  };
}

export interface IUpdateThemeData {
  username: string;
  sessionid: string;
  failstatus: number;
  request: IUpdateTheme;
}

export interface IUpdateThemeRequest {
  // live: any;
  preview: any;
  themebuilder: string;
  loading: boolean;
  error: string | null;
  data?: IUpdateThemeResponse;
}

export interface IUpdateTheme {
  action: string;
  affiliateid: number | null;
  theme: string | null;
}

export interface IUpdateThemeResponse {
  username: string;
  sessionid: string;
  status: number;
  statusMessage: string;
  severity: number;
  data: {};
}

export function isValidResponse(
  response: any
): response is IUpdateThemeResponse {
  return (
    typeof response === "object" &&
    "username" in response &&
    "sessionid" in response &&
    "status" in response &&
    "statusMessage" in response &&
    "severity" in response &&
    "data" in response
  );
}
export interface IThemeGalleryReq {
  username: string;
  sessionid: string;
  failstatus: number;
  request: Record<string, any>;
}

interface ThemePage {
  page: number;
  relativepath: string;
}

interface ThemeGalleryItem {
  themeid: string;
  description: string;
  theme: string;
  pages: ThemePage[];
}

interface GalleryData {
  gallery: ThemeGalleryItem[];
}

export interface IThemeGalleryRes {
  username: string;
  sessionid: string;
  status: number;
  statusMessage: string;
  severity: number;
  data: GalleryData;
}

export interface ProcessedTheme {
  id: string;
  name: string;
  description: string;
  image: string[];
  preview: string;
}

export type TPrivilegeType = {
  value: string;
  label: string;
};